export default __webpack_public_path__ + "static/media/Lato-Regular.2b7b7f6c.ttf";